import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isLinuxFetcher } from '../../../../../../shared/fetchers';
import { Exploitability } from '../../../../../../shared/vulns/types';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import VulnBadge from '../../../../generic/VulnBadge';
import CVEBadge from '../../../../issues/IssuesInbox/IssueItem/CVEBadge';
import EpssBadge from '../../../../issues/IssuesInbox/IssueItem/EpssBadge';
import FixBadge from '../../../../issues/IssuesInbox/IssueItem/FixBadge';
import KnownExploitBadge from '../../../../issues/IssuesInbox/IssueItem/KnownExploitBadge';
import Header from '../../../../shared/vulns/Drawer/Header';

/**
 * Container component for the VulnerabilityDrawerHeader
 */
const PackageVersionVulnerabilityDrawerHeader: VoidFunctionComponent = () => {
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const title = useSelector(PackageInventoryStore.selectors.getSelectedVulnTitle);
  const cvss = useSelector(PackageInventoryStore.selectors.getSelectedVulnCvss);
  const cve = useSelector(PackageInventoryStore.selectors.getSelectedVulnCve);
  const epss = useSelector(PackageInventoryStore.selectors.getSelectedVulnEpss);
  const exploitability = useSelector(PackageInventoryStore.selectors.getExploitability);
  const locatorParts = useSelector(PackageInventoryStore.selectors.getPackageVersionMetadataLocatorParts);
  const remediation = useSelector(PackageInventoryStore.selectors.getSelectedVulnRemediation);
  const isLinuxDep = isLinuxFetcher(locatorParts?.fetcher);
  const shouldShowFixBadge = remediation && !isLinuxDep;

  return (
    <Header
      isLoading={isLoading}
      title={title}
      locatorParts={locatorParts}
      badgesSlot={
        <>
          <VulnBadge cvss={cvss} isTruncated hasTooltip={false} />
          {epss && <EpssBadge tooltipId={`epss-badge-${cve}`} epss={epss} showTooltip={false} />}
          {shouldShowFixBadge && (
            <FixBadge
              version={remediation.partialFix}
              distance={remediation.partialFixDistance}
              showTooltip={false}
            />
          )}
          {cve && <CVEBadge cve={cve} showTooltip={false} /> }
          {exploitability !== Exploitability.Unknown && <KnownExploitBadge showTooltip={false} />}
        </>
      }
    />
  );
};

export default PackageVersionVulnerabilityDrawerHeader;
